import { IComment, ICommentForm } from '../models';

export const commentToFormMapper = (comment?: IComment): ICommentForm => {
    if (comment) return { ...comment, type: comment.external ? 'external' : 'internal' };
    return { message: '', type: 'internal' };
};

export const commentFromFormMapper = (form: ICommentForm, organisationId: string, comment?: IComment): IComment => {
    if (comment) {
        return {
            ...comment,
            message: form.message,
            external: form.type === 'external',
        };
    }

    return {
        ...form,
        external: form.type === 'external',
        timestamp: new Date().toISOString(),
        organisationId,
    };
};
